import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import {
  debounce,
  GENERIC_ERROR_MESSAGE,
  getPageFromObject,
} from '@roc/feature-utils';
import { NewLoanApplicationService } from 'libs/feature-borrower-loan-submission/src/modules/newLoanApplication/services/newLoanApplicationService';
import { action, flow, makeObservable, observable, override } from 'mobx';
import { BorrowerEntityInformationStore } from '../borrowerEntityInformationStore';

const PAGE_SIZE = 20;

export class SearchEntityGridStore extends GridStore {
  private globalStore: GlobalStore;
  private entityStore: BorrowerEntityInformationStore;

  entities: any[] = [];
  searchString = '';

  fetchGridDataDebounced = debounce(() => this.fetchGridData());

  constructor(
    globalStore: GlobalStore,
    entityStore: BorrowerEntityInformationStore
  ) {
    super(() => this.fetchPage(), undefined, PAGE_SIZE);
    this.globalStore = globalStore;
    this.entityStore = entityStore;

    makeObservable(this, {
      searchString: observable,
      reset: override,
      setSearchString: action,
      fetchEntities: flow,
    });
  }

  reset() {
    super.reset();
    this.entities = [];
    this.searchString = '';
    this.gridData.meta.pageSize = PAGE_SIZE;
  }

  *fetchEntities() {
    try {
      this.reset();
      yield this.entityStore.fetchBorrowerEntities();
      this.fetchGridData();
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  setSearchString(searchString) {
    this.searchString = searchString;
    this.fetchGridDataDebounced();
  }

  fetchPage = async () => {
    const rows = this.entityStore.borrowerEntities
      .map(entity => ({
        borrowerEntityId: entity.borrowerEntity.borrowerEntityId,
        companyName: entity.borrowerEntity.name || '',
        borrowers: entity.borrowers.map(borrower => ({
          borrowerName: `${borrower.firstName} ${borrower.lastName}`,
          ownership: borrower.pctOwnership,
        })),
      }))
      .filter(row =>
        row.borrowers
          .map(b => b.borrowerName)
          .concat(row.companyName)
          .some(s =>
            s
              .toLocaleLowerCase()
              .includes(this.searchString.toLocaleLowerCase())
          )
      );
    const data = getPageFromObject(rows, this.gridData.meta);
    return new ApiResponse({ data }, null);
  };
}
